import React from "react";
import { Link } from "react-router-dom";
import { Youtube } from "lucide-react";
import { TiktokIcon } from "./icons/TiktokIcon";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_chudy-logistyka/artifacts/e7s7h7u8_Screenshot%202026-04-22%20at%2011-24-34%2016759a71-7e1b-473a-ab3e-a44c0460777d.png%20%28PNG%20Image%201536%20%C3%97%201024%20pixels%29%20%E2%80%94%20Scaled%20%2890%25%29.png";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-[rgba(212,169,74,0.18)] bg-[#08080a] pt-20 pb-10"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <Link to="/" className="inline-block">
              <img
                src={LOGO_URL}
                alt="Przemysław Chudy — Wsparcie w transporcie"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="mt-8 text-[15px] text-[#b8b3a7] leading-relaxed max-w-md">
              Strategiczne wsparcie dla firm transportowych i spedycyjnych.
              Praktyka, nie teoria. Konkretne działania, nie slajdy.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.26em] uppercase gold-text mb-5">
              Nawigacja
            </div>
            <ul className="space-y-3 text-[14px]">
              {[
                ["/o-mnie", "O mnie"],
                ["/oferta", "Oferta"],
                ["/kalkulator", "Kalkulator"],
                ["/ebooki", "E-booki"],
                ["/video", "Video"],
                ["/dlaczego-ja", "Dlaczego ja"],
                ["/kontakt", "Kontakt"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-[#c9c4b8] hover:text-[var(--gold)] transition-colors"
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.26em] uppercase gold-text mb-5">
              Kontakt
            </div>
            <ul className="space-y-3 text-[14px] text-[#c9c4b8]">
              <li>
                <a href="mailto:kontakt@przemyslawchudy.pl" className="hover:text-[var(--gold)] transition-colors">
                  kontakt@przemyslawchudy.pl
                </a>
              </li>
              <li>
                <a href="tel:+48660341213" className="hover:text-[var(--gold)] transition-colors">
                  +48 660 341 213
                </a>
              </li>
              <li>Cała Polska • online & stacjonarnie</li>
            </ul>
            <div className="mt-6">
              <div className="text-[11px] tracking-[0.26em] uppercase gold-text mb-3">
                Znajdziesz mnie też na
              </div>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.tiktok.com/@chudyprzemyslaw"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-tiktok"
                  aria-label="TikTok"
                  className="h-10 w-10 border border-[rgba(212,169,74,0.3)] flex items-center justify-center text-[var(--gold)] hover:border-[var(--gold)] hover:bg-[rgba(212,169,74,0.06)] transition-all"
                >
                  <TiktokIcon size={16} />
                </a>
                <a
                  href="https://www.youtube.com/@chudyprzemyslaw"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-youtube"
                  aria-label="YouTube"
                  className="h-10 w-10 border border-[rgba(212,169,74,0.3)] flex items-center justify-center text-[var(--gold)] hover:border-[var(--gold)] hover:bg-[rgba(212,169,74,0.06)] transition-all"
                >
                  <Youtube size={16} />
                </a>
                <a
                  href="https://naffy.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-naffy"
                  className="text-[13px] tracking-[0.24em] uppercase text-[#c9c4b8] hover:text-[var(--gold)] transition-colors ml-2"
                >
                  naffy.io →
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="hairline" />

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-[12px] text-[#7a766d] tracking-wide">
            © {year} Przemysław Chudy — Wsparcie w transporcie. Wszystkie prawa zastrzeżone.
          </div>
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#7a766d]">
            Praktyka · Konkret · Wyniki
          </div>
        </div>
      </div>
    </footer>
  );
}
